import React from "react";
import ReactDOM from "react-dom/client";
import "./keyframes.css";
import "./globals.css";
import "./fonts.css";
import Home from "./pages/Home/Home";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import OurTeam from "./pages/OurTeam/OurTeam";
import AboutUs from "./pages/AboutUs/AboutUs";
import ContactUs from "./pages/ContactUs/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Labs from "./pages/Labs/Labs";
import Mind from "./pages/Mind/Mind";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";
import TermsAndConditionsUS from "./pages/TermsAndConditionsUS/TermsAndConditionsUS";
import TermsOfUse from "./pages/TermsOfUse/TermsOfUse";
import TermsOfUseUS from "./pages/TermsOfUseUS/TermsOfUseUS";
import PageChangeHandler from "./components/PageChangeHandler/PageChangeHandler";
import JoiningOptions from "./pages/JoiningOptions/JoiningOptions";
import InformedConsent from "./pages/InformedConsent/InformedConsent";
import CrisisSupport from "./pages/CrisisSupport/CrisisSupport";
import SupportDirectory from "./pages/SupportDirectory/SupportDirectory";
import Security from "./pages/Security/Security";
import { useEffect } from "react";
import { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { loadPolygonMaskPlugin } from "@tsparticles/plugin-polygon-mask";
import ResourceCentre from "./pages/ResourceCentre/ResourceCentre";
import News from "./pages/News/News";
import { PostProvider } from "./components/PostProvider/PostProvider";
import NewsPost from "./pages/NewsPost/NewsPost";
import NewsCategoryResults from "./pages/NewsCategoryResults/NewsCategoryResults";
import NewsSearchResults from "./pages/NewsSearchResults/NewsSearchResults";

const root = ReactDOM.createRoot(document.getElementById("root"));

function Root() {
    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadPolygonMaskPlugin(engine);
            await loadSlim(engine);
        });
    }, []);

    return (
        <React.StrictMode>
            <BrowserRouter>
                <PageChangeHandler />
                <Routes>
                    <Route path="*" element={<Home />} />
                    <Route path="/mind" element={<Mind />} />
                    <Route path="/mind/faq" element={<Mind />} />
                    <Route path="/lab" element={<Labs />} />
                    <Route path="/keellabs" element={<Labs />} />
                    <Route path="/our-team" element={<OurTeam />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route
                        path="/mind/privacy-policy"
                        element={<PrivacyPolicy />}
                    />
                    <Route path="/mind/terms-of-use" element={<TermsOfUse />} />
                    <Route
                        path="/mind/terms-and-conditions"
                        element={<TermsAndConditions />}
                    />
                    <Route
                        path="/mind/us/terms-of-use"
                        element={<TermsOfUseUS />}
                    />
                    <Route
                        path="/mind/us/terms-and-conditions"
                        element={<TermsAndConditionsUS />}
                    />
                    <Route
                        path="/mind/support-directory"
                        element={<SupportDirectory />}
                    />
                    <Route path="/mind/security" element={<Security />} />
                    <Route
                        path="/more-joining-options"
                        element={<JoiningOptions />}
                    />
                    <Route
                        path="/more-joining-options-dev"
                        element={<JoiningOptions forceDev={true} />}
                    />
                    <Route
                        path="/informed-consent"
                        element={<InformedConsent />}
                    />
                    <Route path="/crisis-support" element={<CrisisSupport />} />
                    <Route
                        path="/mind/resource-centre"
                        element={<ResourceCentre />}
                    />
                    <Route
                        path="/mind/news"
                        element={
                            <PostProvider>
                                <News />
                            </PostProvider>
                        }
                    />
                    <Route
                        path="/mind/news/:id"
                        element={
                            <PostProvider>
                                <NewsPost />
                            </PostProvider>
                        }
                    />
                    <Route
                        path="/mind/news/category/:slug"
                        element={
                            <PostProvider>
                                <NewsCategoryResults />
                            </PostProvider>
                        }
                    />
                    <Route
                        path="/mind/news/search"
                        element={
                            <PostProvider>
                                <NewsSearchResults />
                            </PostProvider>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </React.StrictMode>
    );
}

root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export default OurTeam;
